import { Injectable } from "@angular/core";
import { SiAuthenticationService } from "@strategic-insights/ng-authentication";
import { SiDataService } from "../services/si-data.service";
import { Observable, BehaviorSubject, Subject } from "rxjs";
import { Router } from "@angular/router";
declare let $;

@Injectable()
export class SiCustomerCommonService {
  changePasswordModalStatus = new BehaviorSubject<boolean>(false);
  loadingTab = new BehaviorSubject<boolean>(true);
  //sessionExpired = new Subject<void>();
  userGuideURI: string = `s3/ccid/userguide`;
  isUserGuide: boolean = false;
  loader: object = {
    icon: true,
    overlay: true,
    message: true,
  };


  constructor(private siDataService: SiDataService,
    private siAuthenticationService: SiAuthenticationService,
    private router: Router
  ) {}
  /**
   * Logout common service
   * @returns: string
   */
  logout() {
    const self = this;
    return new Observable<boolean>((observer) => {
      self.siAuthenticationService.logout().subscribe(
        (response) => {
          self.siDataService.clearIndexedDB().subscribe({
            next: (res) => {
              if (
                typeof response === "object" &&
                response.logoutRoute !== undefined &&
                response.logoutRoute !== ""
              ) {
                self.navigateToLogout(response.logoutRoute);
              }
              observer.next(true);
              observer.complete();
            },
            error: (err) => {
              if (
                typeof response === "object" &&
                response.logoutRoute !== undefined &&
                response.logoutRoute !== ""
              ) {
                self.navigateToLogout(response.logoutRoute);
              }
              observer.next(true);
              observer.complete();
            },
          });
        },
        (error) => {
          if (
            typeof error === "object" &&
            error.logoutRoute !== undefined &&
            error.logoutRoute !== ""
          ) {
            self.navigateToLogout(error.logoutRoute);
          }
          observer.error(error);
        }
      );
    });
  }


  afterViewInit(myElement) {
    const customerMenu = myElement.nativeElement.querySelector(
      ".dropdown-menu-right"
    );
    const dropdownDivider =
      myElement.nativeElement.querySelector(".dropdown-divider");
    const dropdownReleaseInfo = myElement.nativeElement.querySelectorAll(
      ".rounded-bottom > a"
    );
    if (
      this.siAuthenticationService.getAuthType() &&
      this.siAuthenticationService.getAuthType().toLowerCase() === "sso"
    ) {
      dropdownReleaseInfo[2].classList.add("pointer-none");
      dropdownReleaseInfo[3].classList.add("pointer-none");
    } else {
      dropdownReleaseInfo[3].classList.add("pointer-none");
      dropdownReleaseInfo[4].classList.add("pointer-none");
    }
    if (customerMenu.lastChild.classList) {
      customerMenu.lastChild.classList.add("scrollMenu");
      dropdownDivider.style.margin = "0px";
    }
  }

  navigateToLogout(route = "logout") {
    this.router.navigate([route], {
      queryParams: { isLogout: true },
      skipLocationChange: true,
    });
  }

  /**
   * User Preference
   * @returns: Open window modal
   */
  openPreference() {
    return new Observable<boolean>((observer) => {
      $("#userpreference").modal("show");
      observer.next(true);
      observer.complete();
    });
  }

  openAuditDashboard() {
    return new Observable<boolean>((observer) => {
      sessionStorage.setItem('standaloneRoute', 'auditlog');
      this.router.navigate(['auditlog']);
      observer.next(true);
      observer.complete();
    });
  }
  /**
   * Releases details
   * @returns Observable
   */
  releaseDetails() {
    return new Observable<boolean>((observer) => {
      observer.next(true);
      observer.complete();
    });
  }

  /**
   * Gets user guide obj
   * @returns user guide obj
   */
  getUserGuideObj(): Observable<Array<object>> {
    return new Observable<Array<object>>((observer) => {
      this.siDataService.getData(this.userGuideURI).subscribe(
        (response) => {
          observer.next(response);
          observer.complete();
        },
        (error) => {
          observer.error(error);
          observer.complete();
        }
      );
    });
  }

  /**
   * Changes password
   * @returns Observable
   */
  changePassword() {
    const self = this;
    return new Observable<boolean>((observer) => {
      self.changePasswordModalStatus.next(true);
      self.changePasswordModalStatus.next(false);
      observer.next(true);
      observer.complete();
    });
  }

  setLoadingTab(flag) {
    this.loadingTab.next(flag);
  }
}
